var RoadEditModal = (function (base) {
  __extends(RoadEditModal, base);


  function RoadEditModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  };


  RoadEditModal.prototype.activate = function (roadId) {
    var self = this;
    const isNew = !roadId;
    const url = isNew ? 'api/roads/add' : `api/roads/${roadId}/edit`;

    this.loadContent(url)
      .then($modal => {

        var $form = $('form', $modal);
        var $roadName = $('#Name', $form);
          var $coordinatesCsv = $('#CoordinatesCsv', $form);

          if (!isNew) {
              var coordinates = $coordinatesCsv.val();
              if (typeof coordinates === 'string') {
                  coordinates = MapHelper.parseStringToSplitLatLng(coordinates);
                  if (coordinates === undefined) {
                      coordinates = [[]];
                  }
              } else {
                  coordinates = [MapHelper.convertToLatLng(coordinates)];
              }
              $('#Length').val(MapHelper.getLength(coordinates) / 1000);
          }

        $('.select2', $form).select2();

        FormHelper.init($form, isNew ? 'PUT' : 'POST', 'api/roads');
        FilesUploader.initUploadingOnSubmit(VideoServerSettings.url, $form, 'UploadedFile', () => false, fileType => fileType === 1);

        $modal

          //Кнопка `Сохранить`
          .on('click', '[js=save]', function() {
            $modal.busy();
            $form.send()
              .then(() => self.close({ ok: true }))
              .catch(() => $modal.busy(false));
          })

          //Кнопка `Задать координаты на карте`
            .on('click', '[js=edit-coordinates]', function () {
                var startKm = Number($('#StartKm').val());
            ModalConductor.activate(RoadMapModal, roadId, $roadName.val(), $coordinatesCsv.val(), startKm)
              .closed(modalResult => {
                    if (modalResult.ok) {
                        $coordinatesCsv.val(modalResult.coordinatesCsv);
                        $('#Length').val(modalResult.length || 0);
                    }
                });
          })

          //Кнопка `Выбрать трек ТС`
            .on('click', '[js=show-tracks]', function () {
                var startKm = Number($('#StartKm').val());
              ModalConductor.activate(TrackSelectModal, roadId, $roadName.val(), startKm)
              .closed(modalResult => {
                      if (modalResult.ok) {
                          $coordinatesCsv.val(modalResult.coordinatesCsv);
                          $('#Length').val(modalResult.length || 0);
                      }
                  });
            })

            .on('change', '#StartKm', function() {
                $('#Length').valid();
            });
      });
  };


  return RoadEditModal;
}(BaseModal));
